<template>
  <div class="jt_survey">
    <!-- 集团概况 -->
    <!-- nav -->
    <index-nav></index-nav>
     <!-- bottom -->
    <index-bottom></index-bottom>
    <div class="content">
      <!-- banner -->
      <div class="banner">
        <img src="/statics/images/info/jt_banner.png" alt />
      </div>
      <!-- 关于润邦 -->
      <div class="rbInfo">
        <div class="inner">
          <h3>关于集团</h3>
          <div class="des">
            <span>打造世界知名品牌 成就国际优秀企业</span>
          </div>
          <div class="word" v-html="homeInfo.about"></div>
          <!-- <p>德州润邦环保设备有限公司坐落在朝气蓬勃的山东德州武城，武城是全国致力于新材料及空调、风机、风阀、消防、人防系列设备设计、开发、制造、销售、安装及技术服务于一体的现代化高科技集中生产基地，融科技、自然、人文、生态环境于一体，环境优美、交通便利、地理位置优越。</p>
          <p>德州润邦环保设备有限公司始建于2012年12月，在武城创建了生产基地，不仅拥有在新材料及工业空调领域中先进的生产设备和技术水平、高超的产品质量和性能，而且拥有较高的产品性能价格比，优质完美的客户服务与支持保障。目前公司主要产品有：人防过滤吸收器，手动密闭阀，脚踏两用风机，油网滤尘器，玻璃钢产品、轴流式消防排烟风机、离心式消防排烟风机、轴流式屋顶风机、离心式屋顶风机、各种玻璃钢风机、风机盘管、新风机组、新风换气机、防火阀、调节阀、铝合金风口及通风管道、净化设备、不锈钢铸造系列产品、电厂专用管道筒仓泄压装置、煤仓安全系统、给煤机、清堵机、锅炉酸洗、锅炉卡具及机炉电零配件等，公司在发展中，不断健全管理体系，完善管理手段，通过了三体系认证，且消防产品均有配套3c标签，确保客户消防验收合格。</p>
          <p>公司以“客户满意为方向、产品质量为生命、科技进步为动力、市场需求为追求”为经营理念，创建了管理中心、销售中心、技术开发中心，生产中心、产品展示中心、售后服务中心、质量检测中心、市场信息中心等多个职能部门，有利的保证了企业的快速、健康发展。从产品的设计、制造、检验、安装和售后服务，实现网络化和现代化，增强了企业的竞争能力。</p>
          <p>客户日益增长的需要和期望是润邦向前发展的原动力，润邦基于市场变化持续技术创新和产品创新，不断推出蕴含着现代化观念的产品，以满足客户越来越高的要求。多年来，润邦始终秉承“稳健、进取、创新、高效”的文化理念，坚持诚信为本，打造品牌美誉度，积极抓住发展机遇，在稳健中进取，在进取中创新，在创新中超越，在超越者高效。用卓越的智慧积累卓越的高度，不断注入更现代、更时尚、更和谐的元素，旨在塑造中国企业新形象！</p>
          <p>厚德载物，团结拼搏，稳健在外，热情于心，润邦全体员工真诚期盼与您携手共发展！</p>-->
        </div>
      </div>
      <!-- 企业文化 -->
      <div class="qy_culture">
        <div class="inner">
          <h3>企业文化</h3>
          <div class="qywh">
            <div class="qy_lef">
              <h4>价值观</h4>
              <span>积极抓住发展机遇，在稳健中进取，</span>
              <span>在进取中创新，在创新中超越，在超越者高效。</span>
              <span>用卓越的智慧积累卓越的高度，</span>
              <span>不断注入更现代、</span>
              <span>更时尚、更和谐的元素，</span>
              <span>旨在塑造中国企业新形象！</span>
            </div>
            <div class="qy_pic">
              <img src="/statics/images/info/jt_qy.png" alt />
            </div>
            <div class="qy_rig">
              <div class="rig_top">
                <h4>经营理念</h4>
                <span>客户满意为方向、产品质量为生命、</span>
                <span>科技进步为动力、市场需求为追求</span>
              </div>
              <div>
                <h4>愿景</h4>
                <span>打造世界知名品牌 成就国际优秀企业</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom -->
    <!-- <index-bottom></index-bottom> -->
    <!-- footer -->
    <index-footer></index-footer>
  </div>
</template>

<script>
import indexNav from "./../components/nav";
import indexBottom from "./../components/bottom";
import indexFooter from "./../components/footer";
export default {
  data() {
    return {
      homeInfo: { about: "" }
    };
  },
  components: {
    indexNav,
    indexBottom,
    indexFooter
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      var that = this;
      that.$api.index.index({}).then(function(res) {
        if (res.code == 200) {
          that.homeInfo = res.result;
        }
      });
    }
  },
  mounted: function() {}
};
</script>

<style>
</style>